
const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('pages/Index.vue') },
	    { path: '/test', name: 'test', component: () => import('pages/Test.vue') },
      { path: '/login', name: 'login', component: () => import('pages/Security/Login.vue') },
      { path: '/reset', name: 'reset', component: () => import('pages/Security/Reset.vue') },
      { path: '/logout', name: 'logout', component: () => import('pages/Security/Logout.vue') },
    ]
  },

  {
    path: '/app',
    component: () => import('layouts/SecuredLayout.vue'),
    children: [
      { path: '', name: 'secured_home', component: () => import('pages/Secured.vue') },
      { path: '/app/settings', name: 'settings', component: () => import('pages/Settings/Settings') },
      { path: '/app/users', name: 'users', component: () => import('pages/User/Users') },
      { path: '/app/users/new', name: 'usernew', component: () => import('pages/User/UserNew') },
      { path: '/app/users/inventory/:id', name: 'userInventory', component: () => import('pages/Inventory/Inventory') },
      { path: '/app/users/:id', name: 'useredit', component: () => import('pages/User/UserEdit') },
      { path: '/app/tools', name: 'tools', component: () => import('pages/Tool/Tools') },
      { path: '/app/tools/:id', name: 'toolsEdit', component: () => import('pages/Tool/ToolsEdit') },
      { path: '/app/tools/transfers/:id', name: 'toolsHistory', component: () => import('pages/Tool/Transfers') },
      { path: '/app/tools/attachments/new/:product_id', name: 'toolsAttachmentsNew', component: () => import('pages/Tool/AttachmentNew'), props: true },
      { path: '/app/tools/attachments/:product_id', name: 'toolsAttachments', component: () => import('pages/Tool/ToolAttachments'), props: true },
      { path: '/app/tools/new', name: 'toolsNew', component: () => import('pages/Tool/ToolsNew') },
      { path: '/app/tooltypes', name: 'tooltypes', component: () => import('pages/Tool/Types') },
      { path: '/app/manufacturers', name: 'manufacturers', component: () => import('pages/Tool/Manufacturers') },
      { path: '/app/new_manufacturer', name: 'new_manufacturers', component: () => import('pages/Tool/Manufacturers_new') },
      { path: '/app/transfers', name: 'transfers', component: () => import('pages/Transfer/Transfers') },
      { path: '/app/transferstoprint', name: 'transfersToPrint', component: () => import('pages/Transfer/TransfersToPrint') },
      { path: '/app/transfers/transfer', name: 'transfer', component: () => import('pages/Transfer/Transfer') },
      { path: '/app/transfers/transferweb', name: 'transferweb', component: () => import('pages/Transfer/TransferWeb') },
      { path: '/app/transfers/:id', name: 'transferEdit', component: () => import('pages/Transfer/TransferEdit') },
      { path: '/app/my_inventory', name: 'my_inventory', component: () => import('pages/Inventory/MyInventory') },
      { path: '/app/inventory/external', name: 'extinventory', component: () => import('pages/Inventory/External') },
      { path: '/app/inventory', name: 'inventory', component: () => import('pages/Inventory/Inventory') },
      { path: '/app/inventory/purchase', name: 'purchase', component: () => import('pages/Inventory/Purchase') },
      { path: '/app/stock', name: 'stock', component: () => import('pages/Stock/Stock') },
      //{ path: '/app/stock2', name: 'stock2', component: () => import('pages/Stock/Stock2') },
      { path: '/app/authorize', name: 'authorize', component: () => import('pages/Authorize/Authorize') },
      { path: '/app/authorize/new', name: 'authorizeNew', component: () => import('pages/Authorize/AuthorizeNew') },
      { path: '/app/backgrounds', name: 'backgrounds', component: () => import('pages/Background/Backgrounds') },
      { path: '/app/backgrounds/new', name: 'backgroundNew', component: () => import('pages/Background/BackgroundNew') },
      { path: '/app/qrcodes', name: 'qrcodes', component: () => import('pages/QrCodes/QrCodes') },
    ]
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue')
  }
]

export default routes
